/**
 * Sticky Add to Cart Button
 * Shows a fixed add-to-cart button when scrolling DOWN past the main button
 */

class StickyAddToCart {
  constructor() {
    this.document = document;
    this.observer = null;
    this.stickyContainer = null;
    this.buyButtonsScrolledPast = false;
    this.footerVisible = false;
    this.init();
  }

  init() {
    this.stickyContainer = this.document.querySelector('.product-fixed-add-to-cart');
    if (!this.stickyContainer) return;

    this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px',
    });

    const productAddToCart = this.document.querySelector('.product__qty-and-buy');

    if (productAddToCart) {
      this.observer.observe(productAddToCart);
    }

    const footer = this.document.querySelector('footer');

    if (footer) {
      this.observer.observe(footer);
    }

    this.setupVariantButtonHandler();
  }

  /**
   * For variant products, clicking the sticky button scrolls to the main add-to-cart section
   */
  setupVariantButtonHandler() {
    const stickyLink = this.stickyContainer?.querySelector('a[href^="#ProductInfo"]');
    
    if (stickyLink) {
      stickyLink.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Immediately hide sticky and update state to prevent showing twice
        this.buyButtonsScrolledPast = false;
        this.updateStickyVisibility();
        
        // Scroll to the buy buttons area
        const buyButtonsArea = this.document.querySelector('.product__qty-and-buy');
        
        if (buyButtonsArea) {
          const headerHeight = 150;
          const elementTop = buyButtonsArea.getBoundingClientRect().top + window.pageYOffset;
          
          window.scrollTo({
            top: elementTop - headerHeight,
            behavior: 'smooth'
          });
        }
      });
    }
  }

  /**
   * Handle intersection observer callback
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersection(entries) {
    if (!this.stickyContainer) return;

    entries.forEach((entry) => {
      if (entry.target.classList.contains('product__qty-and-buy')) {

        if (!entry.isIntersecting) {
          this.buyButtonsScrolledPast = entry.boundingClientRect.bottom < 100;
        } else {
          this.buyButtonsScrolledPast = false;
        }
      } else if (entry.target.tagName === 'FOOTER') {
        this.footerVisible = entry.isIntersecting;
      }
    });

    this.updateStickyVisibility();
  }

  /**
   * Update sticky button visibility based on current state
   */
  updateStickyVisibility() {
    if (!this.stickyContainer) return;

    const shouldShowSticky = this.buyButtonsScrolledPast && !this.footerVisible;

    if (shouldShowSticky) {
      this.stickyContainer.classList.remove('fixed-buttons__container--hidden');
    } else {
      this.stickyContainer.classList.add('fixed-buttons__container--hidden');
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddToCart();
  });
} else {
  new StickyAddToCart();
}

export { StickyAddToCart };
